<template>
  <div class="finance-base-bill accounts-payable-bill">
    <div class="header">
      <div class="btn-container">
        <div class="money">
          <div class="key">{{ $t('fms_accounts_refund_bill.tkyjhj') }}：</div>
          <div class="val">￥{{ total }}</div>
        </div>
      </div>
    </div>
    <custom-table
      class="bill-list"
      :tableCode="tableCode"
      :data="data"
      :filterArr="filterArr"
      @filter="filterChange"
      @sort="sortChange"
      :slots="['termNum', 'payTotal']"
    >
      <!-- 本期应付金额 -->
      <template
        slot="payTotal"
        slot-scope="scope"
      >
        {{ getPayTotal(scope.row) }}
      </template>
      <!-- 期数 -->
      <template
        slot="termNum"
        slot-scope="scope"
      >
        <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    value: {
      type: Array
    },
    tableCode: {
      type: String,
      default: 'deposit_refund'
    },
    filterArr: {
      type: Array,
      default() {
        return ['action'];
      }
    }
  },
  computed: {
    data() {
      return this.value;
    },
    total() {
      return this.getTotal('paymentAmount');
    }
  },
  data() {
    return {};
  },
  mounted() {
  },
  watch: {
    value(val) {
      if (val && val.length) {
        this.firstItem = val[0];
      }
    }
  },
  methods: {
    getPayTotal(row) {
      const paymentAmount = row.paymentAmount || 0;
      const breakAmount = row.breakAmount || 0;
      const depositFee = row.depositFee || 0;
      return paymentAmount + breakAmount + depositFee;
    },
    getTotal(key) {
      const list = this.data || [];
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    }
  }
};
</script>

<style lang="scss">
.accounts-payable-bill {
  padding-bottom: 16px;
}
</style>
